module.exports = __webpack_public_path__ + "images/graphic-mall-3_6d96957bc591a1a605b759c3a8468906.png";